const team = {
  state: [
    {
      name: 'Antonio',
      lname: 'Hermano',
      photo: require('@/assets/team/antonio.jpg'),
      pos: 'CEO',
    },
    {
      name: 'Victor',
      lname: 'Silva',
      photo: require('@/assets/team/victor-3.png'),
      pos: 'COO',
      link: 'https://www.linkedin.com/in/nascimentovictor/',
    },
    {
      name: 'Dale',
      lname: 'Smith',
      photo: require('@/assets/team/dale.jpg'),
      pos: 'CSO',
    },
    {
      name: 'Aron',
      lname: 'Castro',
      photo: require('@/assets/team/aron.jpg'),
      pos: 'Blockchain Engineer',
    },
  ],
}

export default team
